"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMemberDayActivity = deleteMemberDayActivity;
exports.getMemberDayActivityDetail = getMemberDayActivityDetail;
exports.getMemberDayActivityList = getMemberDayActivityList;
exports.getPointsRuleList = getPointsRuleList;
exports.saveMemberDayActivity = saveMemberDayActivity;
exports.toggleMemberDayActivityStatus = toggleMemberDayActivityStatus;
exports.uploadMemberDayImage = uploadMemberDayImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取会员日活动列表
 */
function getMemberDayActivityList(query) {
  return (0, _requestAuth.default)({
    url: '/memberDayActivity/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取会员日活动详情（含模块+明细）
 */
function getMemberDayActivityDetail(id) {
  return (0, _requestAuth.default)({
    url: "/memberDayActivity/".concat(id),
    method: 'get'
  });
}

/**
 * 保存会员日活动（新增或更新）
 */
function saveMemberDayActivity(data) {
  return (0, _requestAuth.default)({
    url: '/memberDayActivity',
    method: 'post',
    data: data
  });
}

/**
 * 删除会员日活动
 */
function deleteMemberDayActivity(id) {
  return (0, _requestAuth.default)({
    url: "/memberDayActivity/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用会员日活动
 */
function toggleMemberDayActivityStatus(id, enabled) {
  return (0, _requestAuth.default)({
    url: "/memberDayActivity/toggleStatus/".concat(id),
    method: 'post',
    data: {
      enabled: enabled
    }
  });
}

/**
 * 上传会员日活动图片
 */
function uploadMemberDayImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/memberDayActivity/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取积分兑换规则列表（xy_points_rule，会员日积分兑换专区下拉数据源）
 */
function getPointsRuleList(query) {
  return (0, _requestAuth.default)({
    url: '/xyPointsSelector/pointsRule',
    method: 'get',
    params: query
  });
}